/*
 * @Author: Teemo Ding
 * @Date: 2021-09-03 11:16:20
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-11-23 13:28:58
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/StatusTag/index.tsx
 */
import React from 'react';
import { ESubscriptionBuyStatus } from '@/src/types/common/order';
import css from './css.module.less';

const StatusTag = ({ status, label }) => {
  const tagColor = {
    [ESubscriptionBuyStatus.Active]: {
      color: '#52C41A',
      backgroundColor: '#F6FFED',
    },
    [ESubscriptionBuyStatus.Created]: {
      color: '#FAAD14',
      backgroundColor: '#FFFBE6',
    },

    [ESubscriptionBuyStatus.Cancelled]: {
      color: '#5C6269',
      backgroundColor: '#F4F5F7',
    },
  };
  const t = tagColor[status] || {};
  return (
    <div
      className={css.statusTag}
      style={{
        ...t,
        border: `1px solid ${t.color}`,
      }}>
      {label}
    </div>
  );
};

export default StatusTag;
